import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { GuarantorService } from 'src/app/services/guarantor.service';
import { OwnerService } from 'src/app/services/owner.service';
import { PropertyService } from 'src/app/services/property.service';
import { TenantService } from 'src/app/services/tenant.service';
import {
  of,
  fromEvent,
  Subscription,
  combineLatest,
  BehaviorSubject,
  Observable,
} from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  tap,
  map,
  mergeMap,
} from 'rxjs/operators';

@Component({
  selector: 'app-entities-for-contract-search',
  templateUrl: './entities-for-contract-search.component.html',
  styleUrls: ['./entities-for-contract-search.component.css'],
})
export class EntitiesForContractSearchComponent implements OnInit {
  @Input() searchType: string;
  @Output() selectEntity = new EventEmitter();
  @Output() modalNavigation = new EventEmitter<boolean>();
  @ViewChild('searchBox', { static: true }) searchBox: ElementRef;

  searchTypes = {
    building: {
      id: 1,
      name: 'Inmueble',
    },
    owner: {
      id: 2,
      name: 'Propietario',
    },
    tenant: {
      id: 3,
      name: 'Inquilino',
    },
    guarantor: {
      id: 4,
      name: 'Garante',
    },
  };

  buildingHeader = ['Dirección', 'Identificación'];
  personHeader = ['Nombre', 'Email', 'DNI'];

  searchString: string = '';
  searchResults: any[] = [];
  searchItem: number;
  searchTitle: string;
  totalItems: number = 0;
  searching: boolean = false;
  page: number = 1;
  currentPage$: BehaviorSubject<number> = new BehaviorSubject<number>(1);
  search: Function;
  results$: Observable<any>;

  constructor(
    private ownerREService: OwnerService,
    private propertyREService: PropertyService,
    private tenantREService: TenantService,
    private guarantorREService: GuarantorService,
  ) {}

  ngOnInit() {
    
    if (!this.searchType) {
      console.error('❌ searchType is undefined or null');
      return;
    }
    
    if (!this.searchTypes[this.searchType]) {
      console.error('❌ searchType not found in searchTypes:', this.searchType);
      return;
    }
    
    this.initSearch(this.searchType);
    
    // Cargar opciones iniciales al abrir el modal
    this.loadInitialOptions();
    
    let inputBox$ = fromEvent(
      <HTMLInputElement>this.searchBox.nativeElement,
      'input',
    );
    this.results$ = combineLatest([inputBox$, this.currentPage$]).pipe(
      tap(() => (this.searching = true)),
      debounceTime(750),
      distinctUntilChanged(),
      map(([input, page]) => [
        this.loadQuery((input.target as HTMLInputElement).value),
        page,
      ]),
      mergeMap(([queryString, page]) =>
        this.search(queryString, page, 5).pipe(
          catchError((error) => {
            return of([]);
          }),
          tap(() => {
            this.searching = false;
          }),
        ),
      ),
    );
  }

  private loadInitialOptions() {
    this.searching = true;
    // Cargar las opciones sin filtro usando la página actual
    this.search('', this.page, 5).pipe(
      tap((results) => {
        this.searching = false;
      }),
      catchError((error) => {
        console.error('❌ Error loading initial options:', error);
        this.searching = false;
        return of({ result: [], pagination: { totalItems: 0 } });
      })
    ).subscribe(results => {
      this.searchResults = results.result || [];
      this.totalItems = results.pagination?.totalItems || 0;
    });
  }

  public initSearch(searchType: string) {
    if (!this.searchTypes[searchType]) {
      console.error('❌ Cannot initialize search - searchType not found:', searchType);
      return;
    }
    
    this.searchResults = [];
    this.searchItem = this.searchTypes[searchType].id;
    this.searchTitle = this.searchTypes[searchType].name;
    switch (this.searchItem) {
      case 1:
        this.search = (x, y, z) => {
          return this.propertyREService.searchProperties(x, y, z);
        };
        break;
      case 2:
        this.search = (x, y, z) => {
          return this.ownerREService.searchOwners(x, y, z);
        };
        break;
      case 3:
        this.search = (x, y, z) => {
          return this.tenantREService.searchTenants(x, y, z);
        };
        break;
      case 4:
        this.search = (x, y, z) => {
          return this.guarantorREService.searchGuarantors(x, y, z);
        };
        break;
      default:
        console.log('❌ Unknown search type:', searchType);
        break;
    }
  }

  searchPageChanged(event) {
    this.modalNavigation.emit(true); // Indicar que se está navegando en el modal
    this.page = event;
    this.currentPage$.next(event);
    // Resetear la bandera después de un breve delay
    setTimeout(() => this.modalNavigation.emit(false), 100);
  }

  loadInitialOptionsPage(event) {
    this.modalNavigation.emit(true); // Indicar que se está navegando en el modal
    this.page = event;
    this.loadInitialOptions();
    // Resetear la bandera después de un breve delay
    setTimeout(() => this.modalNavigation.emit(false), 100);
  }

  selectElement(searchElement) {
    this.selectEntity.emit(searchElement);
  }

  loadQuery(qString) {
    if (this.searchItem == 1) {
      const query = `Address=${qString}`;
      return query;
    } else {
      const query = `Name=${qString}`;
      return query;
    }
  }
}
